import { Locale } from 'modules/i18n';

export const plansTranslation = {
  [Locale.en]: {
    currentPlan: 'Current service plan',
    shortCurrentPlan: 'Current',
    startFree: 'Start for free',
    start: 'Get Started',
    freemium: {
      label: 'Freemium',
      title: 'Robust service.',
      subtitle: 'Forever free.',
      price: '$<em>0</em>',
      info1: '30 reqs/sec for Node API',
      info2: '30 reqs/min for Advanced API',
      info3: '{chainsCount}+ chains',
      info4: '1 project',
      info5: 'HTTPS connection',
      info6: 'Community support',
      button: 'Start for Free',
    },
    payAsYouGo: {
      label: 'Pay-as-You-Go',
      title: 'Full service.',
      subtitle: 'Flexible price.',
      price: 'From $<em>10</em><span id="secondary">/100M API Credits</span>',
      info1: '1,5k reqs/sec for Node API',
      info2: '1k reqs/min for Advanced API',
      info3: '{chainsCount}+ blockchains',
      info4: '800+ archive & full nodes',
      info5: '3 projects',
      info6: 'HTTPS / WSS connection',
      info7: 'Support portal',
      button: 'Get Started',
    },
    deal: {
      label: 'Deal',
      title: 'Get more.',
      subtitle: 'Pay less.',
      price: 'From $<em>500</em><span id="secondary">/6B API Credits</span>',
      info1: '1,5k reqs/sec for Node API',
      info2: '1k reqs/min for Advanced API',
      info3: '{chainsCount}+ blockchains',
      info4: '800+ archive & full nodes',
      info5: '3 projects',
      info6: 'HTTPS / WSS connection',
      info7: 'Support portal',
      button: 'Get Started',
    },
    enterprise: {
      label: 'Enterprise',
      title: 'Tailored solution',
      subtitle: 'for professionals.',
      info1: 'Custom terms',
      info2: 'Flexible rate limits',
      info3: 'Preferred chains',
      info4: 'Selected regions',
      info5: 'Engineering team support',
      info6: 'Custom SLA',
      button: 'Contact Us',
    },
    sale: 'Sale',
  },
};
